import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { BASE_URL, Role } from "../../Constants";
import { Select, Switch } from "antd";
const CameraForm = () => {
  const defaultEntity = {
    location: "",
    url: "",
    active: true,
  };

  const inputTypes = ["RTSP", "Local", "NVR"];
  const navigate = useNavigate();
  let { id } = useParams();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [camera, setCamera] = useState(defaultEntity);
  const [isLoading, setIsLoading] = useState(false);
  const [turnServers, setTurnServers] = useState([]);
  const [templates, setTemplates] = useState([]);

  const loadLookups = async () => {
    try {
      let response = await axios.get(`${BASE_URL}/TurnServer`);
      let formattedModels = response.data.map((model) => ({
        value: model.id,
        label: model.name,
      }));
      setTurnServers(formattedModels);
      response = await axios.get(`${BASE_URL}/ModelTemplate`);
      formattedModels = response.data.map((model) => ({
        value: model.id,
        label: model.name,
      }));
      setTemplates(formattedModels);
    } catch (error) {
      console.error("Error fetching lookup Data:", error);
    }
  };
  const onValueChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [objectName, propertyName] = name.split(".");

      setCamera({
        ...camera,
        [objectName]: {
          ...camera[objectName],
          [propertyName]: value,
        },
      });
    } else {
      setCamera({ ...camera, [name]: value });
    }
  };

  const handleSwitchChange = (checked, name) => {
    setCamera((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const onCancelClick = () => {
    navigate("/cameras");
  };
  const fetchData = async () => {
    let res = await axios.get(`${BASE_URL}/Camera/${id}`);
    setCamera(res.data);
  };
  useEffect(() => {
    if (id !== "new") {
      fetchData();
    }
    loadLookups();
  }, [id]);
  const handleChange = (value, option, targetName) => {
    setCamera((pre) => ({ ...pre, [targetName]: value }));
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setIsSubmitted(true);

    if (form.checkValidity()) {
      setIsLoading(true); // Start loading

      try {
        if (id && id !== "new") {
          if (!camera.id) camera.id = id;
          console.log(camera);
          let res = await axios.put(`${BASE_URL}/Camera`, camera);
          if (res.data.id != 400) {
            toast.success("Camera Master updated successfully!");
            navigate(`/cameras/${id}`);
          } else toast.error("Email already exist!");
        } else {
          const res = await axios.post(`${BASE_URL}/Camera`, camera);
          if (res.data !== 400) {
            toast.success("Camera created successfully!");
            navigate(`/cameras/${res.data}`);
          } else {
            toast.error("Username or Email already exist!");
          }
        }
      } catch (err) {
        if (err.response?.status === 400) toast.error(err.response.data);
        else toast.error("An error occurred while creating/updating Camera!");
      } finally {
        setIsLoading(false); // Reset loading
      }
    }
  };
  return (
    <div className="px-7 space-y-2 py-5 bg-zinc-800 text-white w-full min-h-screen">
      <h2
        onClick={onCancelClick}
        className="text-ActiveUsers cursor-pointer text-md text-orange-600 font-semibold"
      >
        Cameras{" "}
        <span className="text-white">
          / {id === "new" ? "New" : "Update"} Camera
        </span>
      </h2>
      <form noValidate onSubmit={onSubmit} className="">
        <div className="flex gap-4">
          <div className="grid grid-cols-2 lg:w-3/5 items-center gap-4 mt-2">
            <div className="">
              <p className="text-sm font-medium">Name</p>
              <input
                type="text"
                name="name"
                value={camera?.name}
                required
                onChange={onValueChange}
                placeholder="Name"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !camera?.name && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className="">
              <p className="text-sm font-medium">Stream URL</p>
              <input
                type="text"
                name="streamUrl"
                required
                value={camera?.streamUrl}
                onChange={onValueChange}
                placeholder="Stream Url"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !camera?.streamUrl && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className="">
              <p className="text-sm font-medium">Input Type</p>
              <Select
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                allowClear
                // className="min-h-16"
                style={{ width: "100%" }}
                placeholder=""
                value={camera?.cameraInputType}
                onChange={(value, option) =>
                  handleChange(value, option, "cameraInputType")
                }
                // options={models}
              >
                {inputTypes.map((item) => (
                  <Select.Option key={item} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
              {isSubmitted && !camera?.cameraInputType && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className="">
              <p className="text-sm font-medium">Turn Server Config</p>
              <Select
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                allowClear
                // className="min-h-16"
                style={{ width: "100%" }}
                placeholder=""
                value={
                  turnServers.length > 0 &&
                  turnServers?.find(
                    (i) => i.value === camera?.turnServerConfigId
                  )?.value
                }
                onChange={(value, option) =>
                  handleChange(value, option, "turnServerConfigId")
                }
                // options={models}
              >
                {turnServers.length > 0 &&
                  turnServers?.map((alarm) => (
                    <Select.Option key={alarm.value} value={alarm.value}>
                      {alarm.label}
                    </Select.Option>
                  ))}
              </Select>
            </div>
            <div className="">
              <p className="text-sm font-medium">Applied Model Templates</p>
              <Select
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                allowClear
                mode="tags"
                style={{ width: "100%" }}
                placeholder=""
                value={camera?.appliedModelTemplates}
                onChange={(value, option) =>
                  handleChange(value, option, "appliedModelTemplates")
                }
              >
                {templates.map((i) => (
                  <Select.Option key={i.value} value={i.value}>
                    {i.label}
                  </Select.Option>
                ))}
              </Select>
              {isSubmitted && !camera?.appliedModelTemplates && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className="">
              <p className="text-sm font-medium">Output Feed URL</p>
              <input
                type="text"
                name="outputFeedUrl"
                value={camera?.outputFeedUrl}
                onChange={onValueChange}
                placeholder="Output Feed URL"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
            </div>
            <div className="">
              <p className="text-sm font-medium">
                Face Identification Template Id
              </p>
              <input
                type="text"
                name="faceIdentificationTemplateId"
                value={camera?.faceIdentificationTemplateId}
                onChange={onValueChange}
                placeholder="Face Identification Template Id"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
            </div>
            <div className="">
              <p className="text-sm font-medium">Retention</p>
              <input
                type="number"
                name="retention"
                value={camera?.retention}
                onChange={onValueChange}
                placeholder="Retention"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
            </div>
            <div className="col-span-2 w-full">
              <div className="grid grid-cols-2 items-center gap-4">
                <div className="col-span-2 font-thin text-lg">
                  Location
                  <div className="w-full border-b border-gray-600" />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Latitude</p>
                  <input
                    type="number"
                    name="location.latitude"
                    value={camera?.location?.latitude}
                    onChange={onValueChange}
                    placeholder="Latitude"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Longitude</p>
                  <input
                    type="number"
                    name="location.longitude"
                    value={camera?.location?.longitude}
                    onChange={onValueChange}
                    placeholder="Longitude"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Address</p>
                  <input
                    type="text"
                    name="location.address"
                    value={camera?.location?.address}
                    onChange={onValueChange}
                    placeholder="Address"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 mt-2 items-center gap-4">
                <div className="col-span-2 font-thin text-lg">
                  Credentials
                  <div className="w-full border-b border-gray-600" />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Token</p>
                  <input
                    type="text"
                    name="credentials.token"
                    value={camera?.credentials?.token}
                    onChange={onValueChange}
                    placeholder="Token"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Username</p>
                  <input
                    type="text"
                    name="credentials.userName"
                    value={camera?.credentials?.userName}
                    onChange={onValueChange}
                    placeholder="Username"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
                <div className="">
                  <p className="text-sm font-medium">Password</p>
                  <input
                    type="password"
                    name="credentials.password"
                    value={camera?.credentials?.password}
                    onChange={onValueChange}
                    placeholder="Password"
                    className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="grid gap-x-4 gap-y-2 mt-8">
              <div className="flex items-center gap-2">
                <p className="text-sm w-4/5 font-medium">Save Feed</p>
                <Switch
                  className="bg-neutral-900"
                  checked={camera.saveFeed}
                  onChange={(checked) =>
                    handleSwitchChange(checked, "saveFeed")
                  }
                  checkedChildren="On"
                  unCheckedChildren="Off"
                />
              </div>
              <div className="flex  items-center gap-2">
                <p className="text-sm w-4/5 font-medium">Playback Enabled</p>
                <Switch
                  className="bg-neutral-900"
                  checked={camera.playbackEnabled}
                  onChange={(checked) =>
                    handleSwitchChange(checked, "playbackEnabled")
                  }
                  checkedChildren="On"
                  unCheckedChildren="Off"
                />
              </div>
              <div className="flex items-center gap-2">
                <p className="text-sm w-4/5 font-medium">
                  Face Identification Enabled
                </p>
                <Switch
                  className="bg-neutral-900"
                  checked={camera.faceIdentificationEnabled}
                  onChange={(checked) =>
                    handleSwitchChange(checked, "faceIdentificationEnabled")
                  }
                  checkedChildren="On"
                  unCheckedChildren="Off"
                />
              </div>
              <div className="flex items-center gap-2">
                <p className="text-sm w-4/5 font-medium">Active</p>
                <Switch
                  className="bg-neutral-900"
                  checked={camera.active}
                  onChange={(checked) => handleSwitchChange(checked, "active")}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end w-2/3 items-end space-x-2 mt-4">
          <button
            type="button"
            className="border-orange-700 border hover:border-orange-800 rounded-md text-white font-semibold px-4 py-2 ml-2"
            onClick={onCancelClick}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-orange-700 hover:bg-orange-800 cursor-pointer disabled:cursor-not-allowed rounded-md text-white font-semibold px-4 py-2 ml-2"
            // onClick={onSubmit}
            disabled={isLoading}
          >
            {id === "new" ? "Create" : "Update"}
          </button>
        </div>
      </form>

      {isLoading && (
        <div
          role="status"
          className="fixed top-0 left-0 flex w-full h-full bg-slate-950 bg-opacity-50 justify-center items-center"
        >
          <svg
            aria-hidden="true"
            class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default CameraForm;
